<template>
  <!--div class="table-container"-->
  <table class="container myTable">
    <col v-for="(val, key) in columnWidths" :style="`width:${val}%;`" :key="key" />
    <thead>
      <tr>
        <th v-for="(field, key) in header" :key="key">
          {{ field }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="click-row"
        v-for="(item, index) in displayData"
        @click="$emit('rowClicked', item, index)"
        :key="index"
      >
        <slot>
          <td v-for="(col, key) in columns" :key="key">
            {{ item[col] }}
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
  <!--div class="debug">
    <p>currPage = {{currPage}}</p>
    <p>theLastPage = {{ theLastPage }}</p>
  </div-->

  <nav>
    <div>
      <a href="#" onclick="event.preventDefault()" @click="firstPage">&lt;&lt;</a>
      <a href="#" onclick="event.preventDefault()" @click="previousPage">&lt;</a>
      <input v-model="currPage" />/
      <input v-model="theLastPage" disabled readonly />
      <a href="#" onclick="event.preventDefault()" @click="nextPage">&gt;</a>
      <a href="#" onclick="event.preventDefault()" @click="lastPage">&gt;&gt;</a>
    </div>
    <div>
      <p style="color: white">
        [displaying {{ props.data.length }} of {{ props.data.length }} records]
      </p>
    </div>
    <!-- <div style="flex:flex-basis; flex-basis: auto;">
      <button type="button" @click="downloadCsv">Download Filtered Data</button>
    </div>-->
  </nav>

  <!--/div>-->
</template>

<script setup lang="ts">
//TODO add pagination to table
import { ref, computed } from 'vue'

const props = defineProps({
  header: Array,
  data: Array,
  columns: Array,
  columnWidths: Array<number>
})

const emits = defineEmits(['rowClicked'])

const rowCount = 20
const currPage = ref(1)

const displayData = computed(() => {
  const startIndex = (currPage.value - 1) * rowCount
  const endIndex = startIndex + rowCount
  return props.data.slice(startIndex, endIndex)
})

const theLastPage = computed(() => {
  return Math.ceil(props.data.length / rowCount)
})

const displayCount = computed(() => {
  return Math.min([props.data.length - currPage.value * rowCount], [10])
})

function previousPage() {
  //currPage.value = Math.max([currPage.value-1, 1]);
  if (currPage.value > 1) {
    currPage.value--
  }
}

function nextPage() {
  //currPage.value = Math.max([currPage.value-1, 1]);
  if (currPage.value < theLastPage.value) {
    currPage.value++
  }
}

function firstPage() {
  currPage.value = 1
}

function lastPage() {
  currPage.value = theLastPage.value
}
</script>

<style lang="css" scoped>
.table-container {
  width: 80%;
  margin: auto;
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
}

nav {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

nav input {
  width: 4rem;
}

/*
button{
    color: white;
    font-size: 0.875rem;
    line-height: 1.25rem;
    height: 2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    margin-top: 0.75rem;
    background-color: rgb(14 165 233);
    border: 2px solid rgb(14 165 233);
    border-radius: 0.375rem;
    cursor: pointer;

}*/

button:hover {
  color: black;
}

button:active {
  border: 2px solid black;
}

a {
  padding: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.75rem;
  color: white;
  font-weight: 500;
  text-decoration: none;
}

a:hover {
  color: black;
}

tr {
  height: 2rem;
}
:slotted(td) {
  height: 2rem;
}
</style>
